import React, { useEffect, useState } from "react";
import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
import { setDashboardLoading } from "../../externalApi/DashboardHostApi";
import { getFeedsInstancePromise } from "../../webUXApi/widgetApi";
export const FullWidgetContainer = (props) => {
    const { showContent } = props;
    const [feedInstance, setFeedInstance] = useState();
    function tryCreateFeedsInstance() {
        getFeedsInstancePromise().then((instance) => {
            setFeedInstance(instance);
        });
    }
    useEffect(() => {
        tryCreateFeedsInstance();
    }, []);
    const feedStateChangeHandler = async (widgetInstance, previousState, currentState) => {
        if (currentState === "normal" || currentState === "error") {
            setDashboardLoading(false);
        }
        else {
            setDashboardLoading(true);
        }
        // TODO: Track metrics relevant to FullWidgetErrorContainer https://microsoft.visualstudio.com/OS/_workitems/edit/41333399
        Trace.logEvent(dashboard, "FullWidgetWithErrorContainerUpdateState", 0 /* verbose */, {
            currentState,
            previousState
        });
    };
    // When enable isFullPageWebXTEnabled(server driven widget) and when feed get errors, should fallback
    // to render the timer/setting button. In this case(error state).
    useEffect(() => {
        if (feedInstance) {
            feedInstance.addStateChangeListener(feedStateChangeHandler);
            // check state instantly
            if (feedInstance.widgetState === "normal" || feedInstance.widgetState === "error") {
                setDashboardLoading(false);
            }
            else {
                setDashboardLoading(true);
            }
        }
        return () => {
            feedInstance && feedInstance.removeStateChangeListener(feedStateChangeHandler);
        };
    }, [feedInstance]);
    return (React.createElement("div", { id: "WidgetsAndFeedDiv", hidden: !showContent, onClick: (e) => { var _a; return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e); } }, props.children));
};
